import React, {ReactNode} from 'react'

interface ModalProps {
    title: string
    children: ReactNode
    onClose: () => void
    isOpen: boolean
    className?: string
    /** Blocks the ✕ and the backdrop while the modal has work in flight. */
    closeDisabled?: boolean
}

const Modal = ({title, children, onClose, isOpen, className, closeDisabled}: ModalProps) => {
    if (!isOpen) return null
    const handleClose = () => {
        if (closeDisabled) return
        onClose()
    }
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
            onClick={handleClose}
        >
            
            <div
                className={`
          relative w-full max-w-3xl mx-4 bg-white shadow-xl
          max-h-[90vh] flex flex-col animate-scaleIn
          ${className}
        `}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b">
                    <h3 className="text-lg font-medium text-gray-900">
                        {title}
                    </h3>
                    <button
                        onClick={handleClose}
                        disabled={closeDisabled}
                        className={`text-gray-400 hover:text-gray-700 text-xl ${closeDisabled ? 'opacity-50' : ''}`}
                    >
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="p-2 overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Modal
